
import type { Product } from './types';

export const castrolProducts: Product[] = [
  {
    id: 'p3',
    shopId: '',
    name: 'Castrol EDGE 5W-30',
    brand: 'castrol',
    price: 150,
    image: 'https://m.media-amazon.com/images/I/61RRj2um3oL._AC_SL1449_.jpg',
    description: 'Advanced full synthetic oil that maximizes engine performance.',
    category: 'oil',
  },
  {
    id: 'msc2',
    shopId: '',
    name: 'Castrol EDGE 5W-30',
    brand: 'castrol',
    price: 150,
    image: 'https://m.media-amazon.com/images/I/61RRj2um3oL._AC_SL1449_.jpg',
    description: 'Advanced full synthetic oil that maximizes engine performance.',
    category: 'oil',
  },
  {
    id: 'msc3',
    shopId: '',
    name: 'Castrol EDGE 0W-20',
    brand: 'castrol',
    price: 170,
    image: 'https://www.nonpaints.com/media/mf_webp/jpg/media/catalog/product/cache/0c0f220016a16f8e545f2eba1c357a9e/c/a/castrol-edge-0w20-ll-olie-4-liter.webp',
    description: 'Advanced synthetic 0W-20 oil for excellent engine protection.',
    category: 'oil',
  },
  // Castrol Magnatec Engine Oil 10W-40
  {
    id: 'magnatec-10w40',
    shopId: '',
    name: 'Castrol Magnatec Engine Oil 10W-40',
    brand: 'castrol',
    price: 110,
    image: 'https://statuscarcare.com/cdn/shop/files/s-l500-2021-02-05T164939.531.jpg?v=1725195390',
    description: 'Castrol Magnatec Engine Oil 10W-40 provides instant protection from the moment you start.',
    category: 'oil',
  }
];
